import pageType from 'Addons/search/pageType';

export default {
  page: {
    typeToSelectorMap: {
      [pageType.home]: 'body.home',
      [pageType.product]: 'body.single-product',
    },
  },
};
